export var FilterType = /*#__PURE__*/ function(FilterType) {
    FilterType["Status"] = "status";
    FilterType["SentBy"] = "sentBy";
    FilterType["SentDate"] = "sentDate";
    FilterType["CompanyName"] = "companyName";
    FilterType["ApprovalDate"] = "approvalDate";
    FilterType["AgreementName"] = "agreementName";
    return FilterType;
}({});
export const filterLabels = {
    ["status"]: 'Status',
    ["sentBy"]: 'Sent by',
    ["sentDate"]: 'Sent date',
    ["companyName"]: 'Company name',
    ["approvalDate"]: 'Approval date',
    ["agreementName"]: 'Agreement name'
};
export var ProposalReportEntryStatus = /*#__PURE__*/ function(ProposalReportEntryStatus) {
    ProposalReportEntryStatus["All"] = "all";
    ProposalReportEntryStatus["NotReviewed"] = "notReviewed";
    ProposalReportEntryStatus["Reviewed"] = "reviewed";
    ProposalReportEntryStatus["Signed"] = "signed";
    ProposalReportEntryStatus["Expired"] = "expired";
    ProposalReportEntryStatus["Withdrawn"] = "withdrawn";
    ProposalReportEntryStatus["Terminated"] = "terminated";
    return ProposalReportEntryStatus;
}({});
